<template>
  <expandable-material-card
    :title="$t('components.portal.logout_urls')"
    :color="$vuetify.theme.themes.light.secondary"
    icon="link"
  >
    <v-card-text>
      <pbas-data-table
        ref="table"
        :showSelect="false"
        :dataProvider="provider"
        :rowActions="rowActions"
        :floatActions="floatActions"
        fileNamePrefix="logout_urls"
        identifier="logout_urls"
        @error="error = $event"
      ></pbas-data-table>
    </v-card-text>

    <v-dialog scrollable v-model="deleteDialog" persistent max-width="400">
      <material-card
        v-if="editedItem"
        :title="$t('components.portal.logout_urls.delete')"
        :color="$vuetify.theme.themes.light.error"
        icon="delete"
      >
        <v-card-text>
          {{ $t("globals.are_you_sure") }}
        </v-card-text>
        <v-card-actions>
          <v-btn color text @click="deleteDialog = false">
            {{ $t("globals.cancel") }}
          </v-btn>
          <v-btn color="error" text @click="tryDelete">
            {{ $t("globals.delete") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <v-dialog scrollable v-model="editDialog" persistent max-width="1200px">
      <material-card
        v-if="editedItem !== null && editedItem !== undefined"
        :title="formTitle"
        :icon="formIcon"
        :color="formColor"
      >
        <v-card-text>
          <v-form ref="form" v-model="valid">
            <v-container fill-height fluid>
              <v-row wrap>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <!-- <v-autocomplete
                    v-model="editedItem.MemberGroup"
                    :label="$t('globals.member_group')"
                    :rules="[$rules.required]"
                    class="required"
                    :items="memberGroups"
                  ></v-autocomplete> -->
                  <no-autocomplete-textfield
                    v-model="editedItem.MemberGroup"
                    :label="$t('globals.member_group')"
                    :rules="[$rules.required]"
                    class="required"
                  ></no-autocomplete-textfield>
                </div>
                <div class="col-12 col-xs-12 col-sm-6 col-md-4">
                  <no-autocomplete-textfield
                    v-model="editedItem.Url"
                    :label="$t('headers.left_drawer_menu_items.url')"
                    :rules="[$rules.required]"
                    class="required"
                  ></no-autocomplete-textfield>
                </div>
              </v-row>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn text @click="close">{{ $t("globals.cancel") }}</v-btn>
          <v-btn :disabled="!valid" color="primary" @click="save">
            {{ $t("globals.save") }}
          </v-btn>
        </v-card-actions>
      </material-card>
    </v-dialog>
    <error-handler :error="error"></error-handler>
  </expandable-material-card>
</template>

<script>
import { mapGetters } from "vuex";
import ErrorHandler from "@/components/ErrorHandler";
import NoAutocompleteTextfield from "@/components/NoAutocompleteTextfield";
import { InMemoryProvider } from "pbas-vue-components";
import getHeaders from "@/headers/LogoutUrls";
import ExpandableMaterialCard from "./ExpandableMaterialCard.vue";

export default {
  components: {
    ErrorHandler,
    NoAutocompleteTextfield,
    ExpandableMaterialCard,
  },
  props: ["items", "memberGroups"],
  data() {
    return {
      error: null,
      deleteDialog: false,
      floatActions: [
        {
          name: "addItem",
          icon: "add",
          color: "#64ba5f",
          text: "globals.add_new",
          handler: () => {
            let item = {
              Email: "",
            };
            this.isNew = true;
            this.editItem(item);
          },
        },
      ],
      rowActions: [
        {
          name: "edit",
          icon: "edit",
          title: "globals.edit",
          handler: (item) => {
            this.isNew = false;
            this.editItem(item);
          },
        },
        {
          name: "delete",
          icon: "delete",
          title: "globals.delete",
          handler: (item) => {
            this.editedItem = item;
            this.deleteDialog = true;
          },
        },
      ],
      editDialog: false,
      valid: true,
      editedItem: null,
      isNew: false,
      provider: undefined,
      uploading: false,
    };
  },
  computed: {
    ...mapGetters("common", ["language", "languages"]),
    ...mapGetters("plansMembers", ["options"]),
    ...mapGetters("common", {
      selectedPlan: "plan",
      settings: "settings",
    }),
    formTitle() {
      return this.isNew
        ? this.$t("components.portal.logout_urls.add")
        : this.$t("components.portal.logout_urls.edit");
    },
    formIcon() {
      return this.isNew ? "add" : "edit";
    },
    formColor() {
      return this.isNew ? this.$vuetify.theme.themes.light.success : this.$vuetify.theme.themes.light.primary;
    },
  },
  watch: {
    items: {
      handler() {
        this.loadPlanData();
      },
    },
  },
  async mounted() {
    this.loadPlanData();
  },
  methods: {
    updateItems(items) {
      this.$nextTick(() => {
        this.$emit("update", items);
      });
    },
    loadPlanData() {
      this.$nextTick(()=>{
        let items = [];
        if (this.items !== null && this.items !== undefined) {
          items = this.items.map((o) => {
            o.Identifier = Math.random().toString();
            return o;
          });
        }
        this.provider = new InMemoryProvider(
          items,
          getHeaders()
        );
        if (this.$refs.table) {
          this.$refs.table.getDataAsync();
          this.$forceUpdate();
        }
      });
    },
    async editItem(item) {
      this.editedItem = JSON.parse(JSON.stringify(item));
      // console.log(this.editedItem);
      this.editDialog = true;
    },
    close() {
      this.editDialog = false;
      this.editedItem = null;
      this.$refs.form.resetValidation();
    },
    save() {
      this.editedItem.PlanIdentityId = this.planIdentityId;
      if (this.isNew) {
        this.add();
      } else {
        this.update();
      }
    },
    async update() {
      const item = this.provider.items.filter(
        (o) => o.Identifier === this.editedItem.Identifier
      )[0];
      const index = this.provider.items.indexOf(item);
      this.provider.items[index] = JSON.parse(JSON.stringify(this.editedItem));
      this.close();
      this.$refs.table.getDataAsync();
      this.updateItems(this.provider.items);
    },
    async add() {
      this.provider.items.push(JSON.parse(JSON.stringify(this.editedItem)));
      this.close();
      this.$refs.table.getDataAsync();
      this.updateItems(this.provider.items);
    },
    async tryDelete() {
      const item = this.provider.items.filter(
        (o) => o.Identifier === this.editedItem.Identifier
      )[0];
      const index = this.provider.items.indexOf(item);
      this.provider.items.splice(index, 1);
      this.deleteDialog = false;
      this.$refs.table.getDataAsync();
      this.updateItems(this.provider.items);
    },
  },
};
</script>
